import { queryOptions, useQuery } from '@tanstack/react-query';

import { getAccountMeta } from '../queries';
import { useAuthStore } from '../stores';

function accountMetaQueryOptions(token: string) {
  return queryOptions({
    queryKey: ['account', 'me'],
    queryFn: () => getAccountMeta(token),
  });
}

export function useAccountMeta() {
  const token = useAuthStore((store) => store.access_token);
  return useQuery(accountMetaQueryOptions(token));
}

export function useIsAuthenticated() {
  const { data } = useAccountMeta();
  if (!data) return false;
  return true;
}
